<template>
<modal :show="show">
    <Loader :loading="loading"></Loader>

    <div class="modal-header">
        <button @click="close" type="button">
            <i class="icon icon-close"></i>
        </button>
    </div>

    <div class="modal-body">
        <img src="img/kolkin-sos-logo.png" /><span>Thank you for using Kolkin SOS!</span>
        <section>
            <p>Your support allows us to continue to provide features and security updates.</p>
            <p>Please update your license at <a href="https://soslist.org/sos/pricing" target="_blank"><u>soslist.org</u></a> before your trial ends in {{serverInfo.grace_days}} day(s)</p>
        </section>
        <label><i class="icon icon-shield-check"></i>Activation Code</label>
        <input v-model="code">
    </div>
    <div class="modal-footer">
        <button @click="updateLicense">
            Update License
        </button>
    </div>
</modal>
</template>

<script>
import Modal from "@/../submodules/vue-base/components/Modal";
import Loader from "@/../submodules/vue-base/components/Loader";
import axios from "axios";
import qs from "qs";
import {
    mapGetters
} from 'vuex';
export default {

    name: 'TrialNagModal',

    components: {
        Modal,
        Loader
    },

    data() {
        return {
            show: false,
            loading: false,
            code: ""
        }
    },

    methods: {
        open() {
            this.code = "";
            this.show = true;
        },

        close() {
            this.show = false;
            this.$emit('close');
        },

        updateLicense() {
            var temp = this;

            var obj = {
                license_id: this.code,
            }
            this.loading = true;
            axios.post('/api/1/license/update', qs.stringify(obj)).then(function (response) {

                if (!response.data.success) {
                    throw "error";
                }
				temp.$store.dispatch("loadServerInfo");
                temp.$store.dispatch("loadSettings").then(function () {
                    temp.loading = false;
                    var toastInstance = temp.$toasted.show("License updated", {
                        duration: "5000",
                        className: "toast-info",
                        position: "top-center"
                    });
                    temp.close();

                });
            }).catch(function (error) {
                temp.loading = false;
            });
        },

        confirm() {
            this.show = false;
            this.$emit('confirm');
        }
    },

    computed: {
        ...mapGetters(["serverInfo"])
    }

}
</script>

<style lang="less" scoped>
@import (reference) "@/assets/less/style.less";

.modal-header {

    padding-bottom: 0;
    button {
        border: none;
        margin-left: auto;
    }
}

.modal-body {

    padding-top: 0;
    padding-bottom: 0;
    section {
        padding-top: 2rem;
        padding-bottom: 1rem;
        p {
            margin-bottom: 1rem;
        }
    }

    img {

        vertical-align: middle;
        height: 50px;
        width: auto;
    }

    label {
        margin-bottom: 0.5rem;
    }
    .icon {
        margin-right: .5rem;
        color: var(--color-green-8);
    }

    span {
        font-weight: bold;

        sub {
            font-size: .4rem;
            color: var(--disabled-color);
            margin-left: 0.01rem;

        }

    }

}
</style>
